import React from 'react';
import { Link } from 'react-router-dom';

const DataRetentionPolicy: React.FC = () => {
  return (
    <div className="prose max-w-3xl mx-auto">
      <h1>Data Retention Policy</h1>
      <p>
        This page describes how long we retain different categories of personal data and the
        criteria used to determine retention periods. We retain data only for as long as
        necessary to provide services, comply with legal obligations, resolve disputes, and
        enforce agreements.
      </p>

      <h2>Key Principles</h2>
      <ul>
        <li>Purpose limitation and storage minimization</li>
        <li>Secure deletion upon expiry of retention period</li>
        <li>Support for user-initiated deletion via DSR</li>
      </ul>

      <h2>Subject Requests</h2>
      <p>
        You can submit a Data Subject Request (DSR) to access, rectify, or delete your data:
        <Link to="/privacy/dsr" className="ml-2 text-indigo-600 underline">Submit a DSR</Link>
      </p>

      <h2>Related Policies</h2>
      <ul>
        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
        <li><Link to="/privacy/cookie-policy">Cookie & Consent Policy</Link></li>
      </ul>

      <p className="text-sm text-gray-500">Last updated: 2025-08-10</p>
    </div>
  );
};

export default DataRetentionPolicy;
